import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Card({
  children,
  className,
  ...rest
}: {
  children: ReactNode;
  className?: string;
} & HTMLAttributes<HTMLDivElement>) {
  // The rest (data-testid, onClick, aria-*) lands on the div, so a card can be found and acted on.
  return (
    <div
      {...rest}
      className={cn(
        'bg-bg-card/85 rounded-card border border-slate-800 p-5 shadow-card',
        className
      )}
    >
      {children}
    </div>
  );
}

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-6">
      <div className="min-w-0">
        <h1 className="text-xl md:text-2xl font-semibold text-muted-strong">{title}</h1>
        {subtitle && <p className="text-sm text-muted mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
